
export interface Address {
  rawAddress: string;
  countryCode: string;
  countryName?: string;
  countryShortName?: string;
  countryLongName?: string;
  street: string;
  city: string;
  postalCode: string;
  number: string;
  floor: string;
  province: string;
  locality: string;
  streetType: string;
  provinceCode?: string;
  streetTypeDescription?: string;
  portal?: string;
  door?: string;
  stair?: string;
  lat?: string;
  lng?: string;
  additionalInfo?: string;
  streetDescription?: string;
  country?: string;
  internationalAddress?: string;
}

export interface Locality {
  code: string;
  name: string;
  postalCodeCount?: number;
}
export interface Province {
  code: string;
  name: string;
}

export interface StreetType {
  code: string;
  aciCode?: string;
  description: string;
  carSinisterCode?: string;
  useAsDefault?: boolean;
}

export interface Country {
  id: string;
  name: string;
  alfa_2: string;
  alfa_3: string;
}


export const COUNTRY_CODE_SPAIN = '0';
export const COUNTRY_SHORT_NAME_SPAIN = 'ES';
export const COUNTRY_LONG_NAME_SPAIN = 'España';
export const COUNTRY_SHORT_NAME_OTHER = 'Otro';
export const STREET_TYPES_RIC: StreetType[] = [
  {
    code: 'ACC',
    carSinisterCode: 'ZZ',
    description: 'ACCESO'
  },
  {
    code: 'ACE',
    carSinisterCode: 'ZZ',
    description: 'ACERA'
  },
  {
    code: 'ACQ',
    carSinisterCode: 'ZZ',
    description: 'ACEQUIA'
  },
  {
    code: 'AFU',
    carSinisterCode: 'ZZ',
    description: 'AFUERA, AFUERAS'
  },
  {
    code: 'AGR',
    carSinisterCode: 'ZZ',
    description: 'AGRUPACION'
  },
  {
    code: 'AL',
    carSinisterCode: 'AL',
    description: 'ALAMEDA'
  },
  {
    code: 'AP',
    carSinisterCode: 'AP',
    description: 'APARTAMENTO'
  },
  {
    code: 'APE',
    carSinisterCode: 'ZZ',
    description: 'APARTADO DE CORREOS'
  },
  {
    code: 'APN',
    carSinisterCode: 'ZZ',
    description: 'APARTADO DE CORREOS'
  },
  {
    code: 'AR',
    carSinisterCode: 'ZZ',
    description: 'ARRABALES'
  },
  {
    code: 'ARR',
    carSinisterCode: 'ZZ',
    description: 'ARRABAL'
  },
  {
    code: 'AUT',
    carSinisterCode: 'ZZ',
    description: 'AUTOPISTA'
  },
  {
    code: 'AVD',
    carSinisterCode: 'AV',
    description: 'AVENIDA'
  },
  {
    code: 'BCO',
    carSinisterCode: 'ZZ',
    description: 'BARRANCO'
  },
  {
    code: 'BDA',
    carSinisterCode: 'ZZ',
    description: 'BARRIADA'
  },
  {
    code: 'BL',
    carSinisterCode: 'BL',
    description: 'BLOQUE'
  },
  {
    code: 'BO',
    carSinisterCode: 'BO',
    description: 'BARRIO'
  },
  {
    code: 'CAS',
    carSinisterCode: 'ZZ',
    description: 'CASA'
  },
  {
    code: 'CH',
    carSinisterCode: 'CH',
    description: 'CHALE'
  },
  {
    code: 'CJN',
    carSinisterCode: 'ZZ',
    description: 'CALLEJA'
  },
  {
    code: 'CJT',
    carSinisterCode: 'ZZ',
    description: 'CONJUNTO'
  },
  {
    code: 'CL',
    carSinisterCode: 'CL',
    description: 'CALLE',
    useAsDefault: true
  },
  {
    code: 'CM',
    carSinisterCode: 'CM',
    description: 'CAMINO'
  },
  {
    code: 'COL',
    carSinisterCode: 'CO',
    description: 'COLONIA'
  },
  {
    code: 'COM',
    carSinisterCode: 'ZZ',
    description: 'COMPLEJO'
  },
  {
    code: 'COO',
    carSinisterCode: 'ZZ',
    description: 'COOPERATIVA'
  },
  {
    code: 'CRA',
    carSinisterCode: 'CR',
    description: 'CARRETERA'
  },
  {
    code: 'CTA',
    carSinisterCode: 'CT',
    description: 'CUESTA'
  },
  {
    code: 'CTJ',
    carSinisterCode: 'ZZ',
    description: 'CORTIJO'
  },
  {
    code: 'DIS',
    carSinisterCode: 'ZZ',
    description: 'DISEMINADO'
  },
  {
    code: 'EDF',
    carSinisterCode: 'ED',
    description: 'EDIFICIO'
  },
  {
    code: 'ENT',
    carSinisterCode: 'ZZ',
    description: 'ENTRADA'
  },
  {
    code: 'FCA',
    carSinisterCode: 'ZZ',
    description: 'FINCA'
  },
  {
    code: 'GPO',
    carSinisterCode: 'GR',
    description: 'GRUPO'
  },
  {
    code: 'GTA',
    carSinisterCode: 'GL',
    description: 'GLORIETA'
  },
  {
    code: 'GV',
    carSinisterCode: 'ZZ',
    description: '"GRANVÍA'
  },
  {
    code: 'LUG',
    carSinisterCode: 'LG',
    description: 'LUGAR'
  },
  {
    code: 'MAS',
    carSinisterCode: 'ZZ',
    description: 'MASÍA'
  },
  {
    code: 'MC',
    carSinisterCode: 'MC',
    description: 'MERCADO'
  },
  {
    code: 'MLE',
    carSinisterCode: 'ZZ',
    description: 'MUELLE'
  },
  {
    code: 'MN',
    carSinisterCode: 'MN',
    description: 'MUNICIPIO'
  },
  {
    code: 'MZ',
    carSinisterCode: 'MZ',
    description: 'MANZANA'
  },
  {
    code: 'NUC',
    carSinisterCode: 'ZZ',
    description: 'NUCLEO'
  },
  {
    code: 'PAT',
    carSinisterCode: 'ZZ',
    description: 'PATIO'
  },
  {
    code: 'PDA',
    carSinisterCode: 'ZZ',
    description: 'PARTIDA'
  },
  {
    code: 'PJE',
    carSinisterCode: 'PJ',
    description: 'PASAJE'
  },
  {
    code: 'POB',
    carSinisterCode: 'PB',
    description: 'POBLADO'
  },
  {
    code: 'POL',
    carSinisterCode: 'PG',
    description: 'POLÍGONO'
  },
  {
    code: 'PQE',
    carSinisterCode: 'PQ',
    description: 'PARQUE'
  },
  {
    code: 'PRL',
    carSinisterCode: 'PR',
    description: 'PROLONGACION'
  },
  {
    code: 'PSO',
    carSinisterCode: 'PS',
    description: 'PASEO'
  },
  {
    code: 'PZA',
    carSinisterCode: 'PZ',
    description: 'PLAZA'
  },
  {
    code: 'PZL',
    carSinisterCode: 'ZZ',
    description: 'PLACETA'
  },
  {
    code: 'RAM',
    carSinisterCode: 'RB',
    description: 'RAMBLA'
  },
  {
    code: 'RDA',
    carSinisterCode: 'RD',
    description: 'RONDA'
  },
  {
    code: 'RSD',
    carSinisterCode: 'ZZ',
    description: 'RESIDENCIA'
  },
  {
    code: 'ROT',
    carSinisterCode: 'ZZ',
    description: 'ROTONDA'
  },
  {
    code: 'SD',
    carSinisterCode: 'ZZ',
    description: '"SINDEFINIR'
  },
  {
    code: 'SDA',
    carSinisterCode: 'ZZ',
    description: 'SENDERO'
  },
  {
    code: 'TRV',
    carSinisterCode: 'TR',
    description: 'TRAVESÍA'
  },
  {
    code: 'URB',
    carSinisterCode: 'UR',
    description: 'URBANIZACIÓN'
  },
  {
    code: 'VIA',
    carSinisterCode: 'VA',
    description: 'VÍA'
  },
  {
    code: 'ZNA',
    carSinisterCode: 'ZZ',
    description: 'ZONA'
  }
];
